import Session from '@/session/service'

export {
  get,
  post,
  put,
  makeRequest
}

function getBaseUrl() {
  return '{{API_BASE_URL}}'
  // switch(process.env.NODE_ENV) {
    // case 'local':
    //   return `http://mlcabs.liverydesk.local:3000/api`;
    // case 'staging':
    //   return `https://staging.liverydesk.com/api`;
    // case 'production':
    //   return `https://production.liverydesk.com/api`;
    // case 'development':
    //   return `https://development.liverydesk.com/api`;
    // default:
    //   return `https://staging.liverydesk.com/api`;
  // }
}

function get(path, payload, callback){
  return makeRequest('GET', path, payload, null, callback);
}

function post(path, payload, callback){
  return makeRequest('POST', path, payload, null, callback);
}

function put(path, payload, callback){
  return makeRequest('PUT', path, payload, null, callback);
}

function makeRequest(method, path, payload, headers, callback) {
  callback = callback || function(){};
  headers = headers || {}

  if (Session.isAuthenticated()) {
    headers['x-access-token'] = Session.getAccessToken();
  }

  headers['Content-Type'] = 'application/json'
  headers['x-api-key'] = Session.getApiKey() || headers['x-api-key'] || null;

  if (path.charAt(0) === "/") {
    path = path.substr(1);
  }

  let url = new URL(`${getBaseUrl()}/${path}`);

  const options = {
    method: method.toUpperCase(),
    headers,
  };

  const isEmptyPayload = !payload || Object.keys(payload).length === 0;

  if (method === 'GET' && !isEmptyPayload) {
    url.search = new URLSearchParams(payload).toString();
  }

  if (method === 'POST' || method === 'PUT'){
    options.body = isEmptyPayload ? null : JSON.stringify(payload);
  }

  return new Promise((resolve, reject) => {
    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          const error = new Error(`API request failed with status: ${response.status}`)
          callback(error)
          return reject(error);
        }
        return response.json()
      })
      .then((response) => {
        if (response.error) {
          if (response.error.code === 'INVALID_ACCESS_TOKEN') {
            const error = new Error('Unauthorized')
            callback(error)
            return reject(error)
          }
          const error = new Error(response.error.message || 'An unknown error occurred')
          callback(error)
          return reject(error)
        }
        const { data, meta } = response
        callback(null, data, meta)
        return resolve(data, meta)
      })
      .catch((error) => {
        callback(error)
        return reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/client.js